// extracted by mini-css-extract-plugin
module.exports = {"protichinta-logo":"mobileLogo-m__protichinta-logo__sH4MW","trust-logo":"mobileLogo-m__trust-logo__6e7D7"};